import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './shared/Icons.css';
import App from './App';

import PatientIcon from '@material-ui/icons/HowToReg';
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';

import values from 'object.values';
import URLSearchParams from 'url-search-params';

import openSocket from 'socket.io-client';
import webrtcAdapter from 'webrtc-adapter'

import { IntlProvider, addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';

import messages_de from './shared/translations/messages_de.json';
import messages_fr from './shared/translations/messages_fr.json';
import messages_it from './shared/translations/messages_it.json';

const localeData = {
  de: messages_de,
  fr: messages_fr,
  it: messages_it
}

addLocaleData([...de, ...fr, ...it]);

let setting = window.localStorage ? window.localStorage.getItem('language') : null;
let language = (navigator.languages && navigator.languages[0]) ||
                     navigator.language ||
                     navigator.userLanguage;
let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

const messages = localeData[setting] || localeData[languageWithoutRegionCode] || localeData[language] || localeData.de;

if (!Object.values) {
	values.shim();
}

const params = new URLSearchParams(document.location.search);

const socket = openSocket('https://ms-comm.z4butrwhlxv8.nooon.io:443', {
  rememberTransport: true, 
  'reconnection': true,
  'reconnectionDelay': 500,
  'secure': true
});

// const socket = openSocket('https://localhost:443');
let locale = localeData[setting] ? setting : localeData[languageWithoutRegionCode] ?  languageWithoutRegionCode : localeData[language] ? language : 'de';

const callMetadata = {
  'patient': {
    icon: PatientIcon,
    type: 'boolean',
    required: true,
    title: {
      'de': 'Ist dieser Teilnehmer ein Patient?',
      'it': 'Questo partecipante è un paziente?',
      'fr': 'Ce participant est-il un patient?',
    },
    values: {
      'de': ['Ja', 'Nein', 'Team'],
      'it': ['Sì', 'No', 'Team'],
      'fr': ['Oui', 'Non', 'Team']
    }
  },
  'medication': {
    icon: ScatterPlotIcon,
    type: 'list',
    showIf: {patient: 0},
    required: true,
    title: {
      'de': 'Welches Medikament?',
      'it': 'Quale farmaco?',
      'fr': 'Quel médicament?',
    },
    values: {
      'de': [
        'Aimovig',
        'Aubagio',
        'Avonex',
        'Betaferon',
        'Copaxone',
        'Enbrel',
        'Forsteo',
        'Gammanorm',
        'Gilenya',
        'Hizentra',
        'Humira',
        'Nexavar',
        'Plegridy',
        'Rebif',
        'Tecfidera',
        'Andere'
      ],
      'it': [
        'Aimovig',
        'Aubagio',
        'Avonex',
        'Betaferon',
        'Copaxone',
        'Enbrel',
        'Forsteo',
        'Gammanorm',
        'Gilenya',
        'Hizentra',
        'Humira',
        'Nexavar',
        'Plegridy',
        'Rebif',
        'Tecfidera',
        'Altri'
      ],
      'fr': [
        'Aimovig',
        'Aubagio',
        'Avonex',
        'Betaferon',
        'Copaxone',
        'Enbrel',
        'Forsteo',
        'Gammanorm',
        'Gilenya',
        'Hizentra',
        'Humira',
        'Nexavar',
        'Plegridy',
        'Rebif',
        'Tecfidera',
        'Autres'
      ]
    }
  }
};

// add metadata strings to messages
Object.keys(callMetadata).forEach(k => {
  messages[['metadata', k, 'title'].join('.')] = callMetadata[k].title[locale];

  callMetadata[k].values[locale].forEach((c, ix) => {
    messages[['metadata', k, 'values', ix].join('.')] = c;
  });
});

console.log(messages);

ReactDOM.render(
  <IntlProvider locale={locale} messages={messages}>
    <App
      locale={locale}
      socket={socket}
      clientprefix="go"
      callMetadata={callMetadata}
    />
  </IntlProvider>,
document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js